import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import { FaChartLine } from 'react-icons/fa';
import { ConstantsSectionProps } from '../types/types';

const ConstantsSection: React.FC<ConstantsSectionProps> = ({
  tripTime,
  rigCost,
  setTripTime,
  setRigCost
}) => {
  const ChartLineIcon: React.FC<{ className?: string }> = ({ className }) => {
    const IconComponent = FaChartLine as any;
    return <IconComponent className={className} />;
  };
  return (
    <Card className="mb-4 section">
      <Card.Header as="h2">
        <ChartLineIcon className="me-2" /> CONSTANTS
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Card className="subsection">
              <Card.Body>
                <Form.Group className="mb-3" controlId="tripTime">
                  <Form.Label>Trip Time (hours)</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter trip time"
                    value={tripTime}
                    onChange={e => setTripTime(e.target.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid trip time.
                  </Form.Control.Feedback>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="subsection">
              <Card.Body>
                <Form.Group className="mb-3" controlId="rigCost">
                  <Form.Label>Rig Cost per Hour ($)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter rig cost"
                    value={rigCost}
                    onChange={e => {
                      const inputValue = e.target.value;
                      const numericValue = inputValue.replace(/[^0-9.]/g, '');
                      const parts = numericValue.split('.');
                      const cleanValue =
                        parts.length > 2
                          ? parts[0] + '.' + parts.slice(1).join('')
                          : numericValue;
                      setRigCost(cleanValue);
                    }}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid rig cost.
                  </Form.Control.Feedback>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ConstantsSection;
